import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashbaordPage from '../../Pages/DashbaordPage';
import Error404 from '../../Pages/Error404';
import PageManagemet from '../../Pages/Workspace/WorkspacePage';
import WorkspacePage from '../../Pages/Workspace/WorkspacePage';
import EnquiryPage from '../../Pages/Workspace/EnquiryPage';
import QuotationPage from '../../Pages/Workspace/QuotationPage';
import InvoicePage from '../../Pages/Workspace/InvoicePage';
import FinancePage from '../../Pages/Workspace/FinancePage';
import ManageServices from '../../Pages/Manage/ManageServices';
import CreateEnquiry from '../../components/Manage/Enquiry/CreateEnquiry';
import UserManage from '../../Pages/Manage/Users/UserManage';
import BankDetailsPage from '../../Pages/Manage/BankDetails/BankDetailsPage';
import ManageLetters from '../../Pages/Manage/ManageLetters/ManageLetters';
import CreateQuotation from '../../components/Manage/Quotation/CreateQuotation';
import EditViewQuotation from '../../components/Manage/Quotation/EditView/EditViewQuotation';
import ProjectsPage from '../../Pages/Workspace/ProjectsPage';
import EmployeesPage from '../../Pages/Manage/Employees/EmployeesPage';
import CreateProjects from '../../components/Manage/Projects/CreateProjects';
import CreateInvoice from '../../components/Manage/Invoice/CreateInvoice';
import ViewInvoice from '../../components/Manage/Invoice/ViewInvoice';
import ProjectMapping from '../../components/Manage/Invoice/ProjectMap/ProjectMapping';
import ExpensePage from '../../Pages/Manage/Expenses/ExpensePage';
import ManageVendors from '../../components/Manage/Vendor/ManageVendors';
import ManagePermission from '../../Pages/Manage/Permission/ManagePermission';
import ListAllAnnouncement from '../../components/Announcements/ListAllAnnouncement';
import LeaveManagement from '../../components/LeaveManagement/DisplayLeave';
import LeaveRequest from '../../components/LeaveRaise/LeaveRequest';

import ProjectTimeline from '../../components/TaskManagement/ProjectTimeline';
import ListProject from '../../components/TaskManagement/ListProject';
import TaskManagement from '../../components/TaskManagement/TaskTracker';
import AssignedTask from '../../components/TaskManagement/AssignedTask';
import MyTask from '../../components/TaskManagement/MyTask';
import AllActions from '../../components/LeaveManagement/AllActions';
import ManageOrganization from '../../Pages/Manage/Organization/ManageOrganization';
import SalaryIssues from '../../components/LeaveManagement/SalaryIssues';
import ManagePO from '../../components/Manage/PurchaseOrder/ManagePO';
import CreatePO from '../../components/Manage/PurchaseOrder/CreatePO';
import ManagePe from '../../components/Manage/Expenses/ProjectExpense/ManageProEx';
import ManageUtilityBill from '../../components/Manage/Expenses/UtilityBill/ManageUtilityBill';
import PlReport from '../../components/Reports/PlReport';
import PaymodeViseReport from '../../components/Reports/PaymodeViseReport';
import ProfilePage from '../../Pages/Manage/Users/ProfilePage';

const allRoutes = [
  { url: "", component: <DashbaordPage /> },
  { url: "/dashboard", component: <DashbaordPage /> },
  { url: "/workspace", component: <WorkspacePage /> },
  { url: "/enquiry", component: <EnquiryPage /> },
  { url: "/quotation", component: <QuotationPage /> },
  { url: "/invoice", component: <InvoicePage /> },
  { url: "/finance", component: <ExpensePage /> }, //FinancePage
  { url: "/manage-services", component: <ManageServices /> },
  { url: "/manage-user", component: <UserManage /> },
  { url: "/manage-bank-data", component: <BankDetailsPage /> },
  { url: "/enquiry/create", component: <CreateEnquiry /> },
  { url: "/manage-letter-formats", component: <ManageLetters /> },
  { url: "/quotation/create", component: <CreateQuotation /> },
  { url: "/quotation/edit", component: <EditViewQuotation /> },
  { url: "/manage-employees", component: <EmployeesPage /> },
  { url: "/projects", component: <ProjectsPage /> },
  { url: "/projects/create", component: <CreateProjects /> },
  { url: "/projects/view", component: <CreateProjects /> },
  { url: "/projects/edit", component: <CreateProjects /> },
  { url: "/invoice/create", component: <CreateInvoice /> },
  { url: "/invoice/view", component: <ViewInvoice /> },
  { url: "/invoice-wise-projects", component: <ProjectMapping /> },
  { url: "/manage-expense", component: <ExpensePage /> },
  { url: "/payments", component: <ExpensePage /> },
  { url: "/manage-vendor", component: <ManageVendors /> },
  { url: "/manage-permission", component: <ManagePermission /> },
  { url: "/announcements", component: <ListAllAnnouncement /> },
  { url: "/workforce-management", component: <LeaveManagement /> },
  { url: "/workforce-management/actions", component: <AllActions /> },

  { url: "/workforce-management/actions/add-leave", component: <AllActions /> },
  { url: "/workforce-management/actions/add-salary", component: <AllActions /> },
  { url: "/workforce-management/actions/documentation-upload", component: <AllActions /> },
  { url: "/workforce-management/actions/generate-offerletter", component: <AllActions /> },
  { url: "/workforce-management/actions/attendance-report", component: <AllActions /> },
  { url: "/workforce-management/actions/salary-issues", component: <AllActions /> },

  { url: "/leave-request", component: <LeaveRequest /> },
  { url: "/manage-task", component: <ListProject /> },
  { url: "/project-timeline", component: <ProjectTimeline /> },
  { url: "/manage-task/create-task", component: <TaskManagement /> },
  { url: "/assigned-task", component: <AssignedTask /> },
  { url: "/my-task", component: <MyTask /> },
  { url: "/manage-organization", component: < ManageOrganization /> },
  { url: "/salary-issues", component: <SalaryIssues /> },
  
  { url: "/purchase-order", component: <ManagePO /> },
  { url: "/purchase-order/create", component: <CreatePO /> },
  { url: "/project-expenses", component: <ManagePe /> },
  { url: "/project-expenses/create", component: <CreatePO /> },
  { url: "/utility-bills", component: <ManageUtilityBill /> },
  { url: "/finance/reports/p-l", component: <PlReport /> },
  { url: "/finance/reports/pay-mode-vise", component: <PaymodeViseReport /> },
  { url: "/profile", component: <ProfilePage /> },

];

const AppRoutes = () => {
  return (
    <Routes>
      {allRoutes.map((route, index) => (
        <Route
          key={index}
          path={route.url}
          element={route.component}
        />
      ))}

      s      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
      />
      {/* Handle 200 */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default AppRoutes;